// extracted by mini-css-extract-plugin
export default {"gainfulbutton":"WG","borderRadius":"XG","disabled":"YG","widthFourty":"ZG","widthSixty":"aH","fullwidth":"bH","accountEditSubscriptionBtn":"cH","accountRdBtn":"eH","accountProductBtn":"fH","accountBannerBtn":"gH","upProductTopBanner":"hH","upProductGainfulTile":"iH","disabledBtn":"jH","buttonsmall":"kH","buttonlarge":"lH","buttonxlarge":"mH","high":"nH"};
    if(module.hot) {
      // 1714422956323
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  